import { render, staticRenderFns } from "./company_details.vue?vue&type=template&id=87572dea&"
import script from "./company_details.vue?vue&type=script&lang=js&"
export * from "./company_details.vue?vue&type=script&lang=js&"
import style0 from "./company_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "company_details.vue"
export default component.exports